<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';

  let {
    headingText,
    headingLevel = 'h2',
    noPadding = false,
    alignLeft = false,
    content = undefined,
    dataTestId = 'marketing-section-header',
  } = $props();
</script>

<div
  class="mt-4"
  class:lg:mt-8={!noPadding}
  class:mb-8={!noPadding}
  class:lg:mb-12={!noPadding}
  data-testid={dataTestId}
>
  <div
    class="mx-auto max-w-6xl text-left flex flex-col"
    class:sm:items-center={!alignLeft}
    class:sm:text-center={!alignLeft}
  >
    <BaseHeading
      className={`leading-tight font-semibold text-blue-dark-navy text-lg md:text-xl lg:text-2xl ${
        !alignLeft ? 'max-w-136 lg:max-w-162 sm:text-center' : ''
      }`}
      {headingLevel}
    >
      {headingText}
    </BaseHeading>
    {#if content}
      <div
        class="my-4 md:text-lg markdown-wrapper"
        class:lg:mx-auto={!alignLeft}
        class:max-w-136={!alignLeft}
        class:lg:max-w-162={!alignLeft}
      >
        {@html content}
      </div>
    {/if}
  </div>
</div>
